import { parseDocument } from 'htmlparser2';
import { getElementsByTagName, textContent, getOuterHTML } from 'domutils';

export function articleNavigation(html = '') {
  const document = parseDocument(html);
  const elements = getElementsByTagName('*', document.children);
  const used = new Set(elements.map(node => node.attribs?.id).filter(Boolean));
  const headings = [];
  for (const node of elements) {
    if (node.name === 'ol' && !node.attribs.start && !node.attribs.reversed && !node.attribs.type) {
      const items = node.children.filter(child => child.name === 'li');
      if (items.length >= 2 && items.length <= 12 && !items.some(item => item.attribs?.value) && !node.children.some(child => child.name === 'ol')) {
        const classes = new Set((node.attribs.class || '').split(/\s+/).filter(Boolean));
        classes.add('article-process');
        node.attribs.class = [...classes].join(' ');
      }
    }
    if (!['h2', 'h3'].includes(node.name)) continue;
    const title = textContent(node).replace(/\s+/g, ' ').trim();
    if (!title) continue;
    if (!node.attribs.id) {
      const base = `section-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'heading'}`;
      let id = base;
      for (let suffix = 2; used.has(id); suffix++) id = `${base}-${suffix}`;
      node.attribs.id = id;
      used.add(id);
    }
    headings.push({ id: node.attribs.id, title, level: Number(node.name[1]) });
  }
  return { html: getOuterHTML(document), headings };
}
